export const START_ROLLOUT_TASK = 'START_ROLLOUT_TASK_MODAL/START_TASK';
export const START_ROLLOUT_TASK_DONE =
  'START_ROLLOUT_TASK_MODAL/START_TASK_DONE';

export const OPEN_START_TASK_MODAL = 'START_ROLLOUT_TASK_MODAL/OPEN_MODAL';
export const CLOSE_START_TASK_MODAL = 'START_ROLLOUT_TASK_MODAL/CLOSE_MODAL';
